module.exports = __webpack_public_path__ + "static/blue-logo@3x-23989c61c59dab36fb750d73b394563b.png";